import gameData from "../gameData";

export default function muteButton(scene, depth)
{
    scene.SoundOnButton = scene.addButton(scene.mid.x+scene.mid.x - 50,scene.mid.y + scene.mid.y - 40, "Btn_SoundOff.png", null, ()=>{
        scene.SoundOnButton.setEnabled(false);
        scene.SoundOnButton.setVisible(false);
        scene.SoundOffButton.setEnabled(true);
        scene.SoundOffButton.setVisible(true);
        gameData.bgMusic.play("bcc_jingle");
        gameData.gameMuted = false;
        scene.HomeButton.playSound = true;
    });

    scene.SoundOnButton.setOrigin(.5,.5);
    if(depth)scene.SoundOnButton.setDepth(depth);

    scene.SoundOffButton = scene.addButton(scene.mid.x+scene.mid.x - 50,scene.mid.y + scene.mid.y - 40, "Btn_SoundOn.png", null, ()=>{
        scene.SoundOnButton.setEnabled(true);
        scene.SoundOnButton.setVisible(true);
        scene.SoundOffButton.setEnabled(false);
        scene.SoundOffButton.setVisible(false);
        //scene.sound.stopByKey("bcc_jingle");
        gameData.bgMusic.stop();
        gameData.gameMuted = true;
        scene.HomeButton.playSound = false;
    });

    scene.SoundOffButton.PlaySound = false;
    if(gameData.gameMuted === true)
    {
        scene.SoundOffButton.setEnabled(false);
        scene.SoundOffButton.setVisible(false);
    }
    else
    {
        scene.SoundOnButton.setEnabled(false);
        scene.SoundOnButton.setVisible(false);
    }

    scene.SoundOffButton.soundKey = "button_menu_click";
    if(gameData.gameMuted === true)
    {
        scene.SoundOffButton.PlaySound = false;
    }

    scene.SoundOnButton.soundKey = "button_menu_click";
    if(gameData.gameMuted === true)
    {
        scene.SoundOnButton.PlaySound = false;
    }


    scene.SoundOffButton.setOrigin(.5,.5);
    if(depth)scene.SoundOffButton.setDepth(depth);
}